import React, { ReactNode, useEffect } from "react"

type ModalCustomProps = {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
  maxWidth?: number
  maxHeight?: number
  closeOnOverlayClick?: boolean
  className?: string
}

export const ModalCustom: React.FC<ModalCustomProps> = ({
  isOpen,
  onClose,
  children,
  maxWidth = 80,
  maxHeight = 90,
  closeOnOverlayClick = true,
  className = "",
}) => {
  // Gestion de l'échappement avec la touche ESC
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && isOpen) {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener("keydown", handleEscape)
      // Empêcher le scroll du body quand la modal est ouverte
      document.body.style.overflow = "hidden"
    }

    return () => {
      document.removeEventListener("keydown", handleEscape)
      document.body.style.overflow = "unset"
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget && closeOnOverlayClick) {
      onClose()
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      onClick={handleOverlayClick}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />

      {/* Modal */}
      <div
        className={`
          relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl h-full
          w-full mx-4 flex flex-col
          overflow-hidden 
          animate-in fade-in-0 zoom-in-95 duration-200 max-h-[90vh]
          ${className}
        `}
        style={{
          maxWidth: `${maxWidth}vw`,
          maxHeight: `${maxHeight}vh`,
        }}
      >
        {/* Content */}
        <div className="flex flex-col flex-1">{children}</div>
      </div>
    </div>
  )
}
